export function ZodLabel({ getLabel, setLabel }) {
    return {
        id: 'ZodLabel',
        value: (Schema) => ({
            label: {
                get() {
                    return getLabel(this) || null;
                }
            },
            setLabel: {
                value(label) {
                    return setLabel(this, label);
                }
            }
        })
    };
}
